import React, { useContext } from 'react';
import './_error.scss';
import error from '../../assets/404.png';
import { OrderDetailsContext } from '../../context/OrderDetailsContext';
import logo from '../../assets/Nandus.png';

const Error = () => {
  const { isError } = useContext(OrderDetailsContext);

  return (
    <>
      <header className="header">
        <nav className="headerNavbar">
          <div className="site-logo-big">
            <img src={logo} alt="" />
          </div>
        </nav>
      </header>
      <div
        className={`errorSection ${isError ? 'errorMargin' : 'normalMargin'}`}
      >
        <div className="errorContainer">
          <div className="info">
            <div className="number">4</div>
            <div className="imgContainer">
              <img src={error} alt="" />
            </div>
            <div className="number">4</div>
          </div>
          <div className="tagLine">
            You are trying to track an order with an invalid link.
          </div>
          <div className="tagLine mt-5">Please check your link again.</div>
          {/* <div className="buttonContainer">
            <button className="homeBtn">
              <a
                href="https://www.nandus.com/"
                target="_blank"
                rel="noreferrer"
              >
                Continue to shopping
              </a>
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Error;
